import React from 'react';

import RichContent from '../../utility/components/rich-content';
import AccessibleElement from '../../ui/components/accessible-element';
import { withError } from '../../shared/components/error-boundary';

import '../css/disclaimer.less';

class SEOParagraph extends React.PureComponent {

  static defaultProps = {
    seoParagraph: {}
  }

  constructor(props) {
    super(props);
    this.state = {
      showSEOParagraph: this.props.showSEOParagraph || false,
    }
  }

  toggleSEOParagraph = () => {
    this.setState({
      showSEOParagraph: !this.state.showSEOParagraph,
    });
  }

  contentRendered = () => {
    const { seoParagraph } = this.props;

    /**
     * No seo paragraph, no visual content!
     */
    if (!seoParagraph) {
      return false;
    }

    let parsedParagraph = typeof seoParagraph === 'string'
      ? JSON.parse(seoParagraph)
      : seoParagraph;

    /**
     * If there's just nothing but an empty object {}
     */
    if (!Object.keys(parsedParagraph).length) {
      return false;
    }

    /**
     * If there's only one line && that line is empty
     */
    const { blocks=[] } = parsedParagraph;
    if (blocks.length === 1 && blocks[0].text.trim() === "") {
      return false;
    }

    return true;
  }

  render() {
    const { showSEOParagraph } = this.state;
    const { seoParagraph, className } = this.props;

    return (
      <span>
        {this.contentRendered() && (
          <div className={`seo-section${className ? ' ' + className : ''}`}>
            <AccessibleElement
              element="div"
              onClick={this.toggleSEOParagraph}
              className={"more-about-products " + (showSEOParagraph ? "active" : "inactive")}
            >
              More about these products
            </AccessibleElement>
            <div className={"seo-paragraph" + (this.state.showSEOParagraph ? " show" : "")}>
              <RichContent raw={seoParagraph} />
            </div>
          </div>
        )}
      </span>
    );
  }
}

export default withError(SEOParagraph);
